exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tmr-export-container[data-v-7e3e8ea8] {\n  padding: 25px;\n  max-width: 600px;\n  margin: auto;\n}\n", ""]);

// exports
